let observers = []

export default {
  bind: (el, binding, vnode) => {
    // Save observer config in the element itself
    el.intersectionObserverConfig = {
      callback: binding.value.callback,
      root: binding.value.root,
      stop: binding.value.stop,
      once: binding.modifiers.once,
      vnode,
      index: null,
    }
    
    // Check if we already have an observer for the root
    let isRootAlreadyObserved = false
    if (observers.length) {
      observers.forEach((observer, index) => {
        if (observer.root === binding.value.root) {
          isRootAlreadyObserved = true
          // Observe the element via the existing observer
          el.intersectionObserverConfig.index = index
          observer.observer.observe(el)
        }
      })
    }

    if (!isRootAlreadyObserved) {
      // Create new observer
      observers.push({
        observer: new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              const config = entry.target.intersectionObserverConfig
              // Pass ratio and context to the callback of the element
              if (config.callback instanceof Function) {
                config.callback(entry.intersectionRatio, config.vnode)
              }
              // If 'once' modifier or stop value is set, then stop observing this element
              let stopValue = config.stop ?? (config.once ? 0.01 : null)
              if (stopValue !== null && entry.intersectionRatio >= stopValue) {
                observer.unobserve(entry.target)
              }
            })
          }, {
            root: binding.value.root || null,
            rootMargin: "0px",
            threshold: Array.from({ length: 101 }, (v, k) => k / 100), // generates a threshold for every percentage
          }),
        root: binding.value.root,
      })

      // Observe the element via the newly created observer
      el.intersectionObserverConfig.index = observers.length - 1
      observers[observers.length - 1].observer.observe(el)
    }
  },
  unbind: (el) => {
    // Remove element from its observer
    if (observers[el?.intersectionObserverConfig?.index]) {
      observers[el.intersectionObserverConfig.index].observer.unobserve(el)
    }
  },
}